import { AppEnum, AppEnumHelper, TaskEnums } from "@/Shared";

import { TaskModel } from "../TaskModel";
import { TaskFormValues } from "../TaskFormValidation";


export class TaskFormViewModel {
    public id: number;
    public categoryLabel: string;
    public category: string;
    public label!: string;

    public constructor(
        private viewEnums: TaskEnums,
        private _task?: TaskModel) {
        
        this.category = _task?.category ?? "";
        this.categoryLabel = AppEnumHelper.getLabel(this.viewEnums.TaskCategoryEnum, this._task?.category);

        this.label = _task?.label ?? "";

        this.id = _task?.id ?? 0;
    }


    get formValues() {
        return {
           id : this.id,
           category : this.category,
           label : this.label
        } as TaskFormValues;
    }

    getCategoryOptions(): AppEnum[] {
        return [{ key: "", value: "", label: "Choisir la nature de la tâche" }, ...this.viewEnums.TaskCategoryEnum];
    }

    getTitle = () => {
        return this._task ? "Tâche N° " + this.id + " - " + this.categoryLabel?.toUpperCase() : "Création de tâche";
    }

    isCreationMode = () => !this.id;
}